theme.SlideShow = (function () {
  function Slider(e) {
    let sliderWrapper = e.querySelector(".hero__slider--activation");

    if (!sliderWrapper) return;

    // Prevent multiple initialization
    if (sliderWrapper.dataset.swiperInitialized === "true") {
      return;
    }

    const allowedSectionId = "20307032703143__slideshow_jMmzmb";
    const sectionId = e.dataset.sectionId || e.id || "";
    const isHomeHero = sectionId.includes(allowedSectionId);

    let slideLoop = e.dataset.slideLoop === "true",
      slideAutoplay = e.dataset.slideAutoplay === "true",
      autoplayDuration = parseInt(e.dataset.autoplayDuration) || 5000,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow) || 0,
      sliderPerView = parseInt(e.dataset.slidesperview) || 1,
      smallDesktop = parseInt(e.dataset.samlldesktopview) || 1,
      tabletShow = parseInt(e.dataset.showTablet) || 1,
      mobileShow = parseInt(e.dataset.showMobile) || 1;

    // Destroy old swiper
    if (sliderWrapper.swiper) {
      sliderWrapper.swiper.destroy(true, true);
    }

    // Clear pagination
    if (sliderPagination) {
      sliderPagination.innerHTML = "";
    }

    let autoplay = false;

    if (slideAutoplay) {
      autoplay = {
        delay: autoplayDuration,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      };
    }

    const swiper = new Swiper(sliderWrapper, {
      slidesPerView: mobileShow,
      loop: slideLoop,
      autoplay: autoplay,
      speed: isHomeHero ? 2000 : 600,
      spaceBetween: isHomeHero ? 0 : slideShowSpace,

      effect: isHomeHero ? "fade" : "slide",

      fadeEffect: isHomeHero
        ? {
            crossFade: true,
          }
        : undefined,

      pagination: {
        el: sliderPagination,
        clickable: true,
      },

      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },

      breakpoints: {
        0: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: smallDesktop,
        },
        1200: {
          slidesPerView: sliderPerView,
        },
      },
    });

    // Mark initialized
    sliderWrapper.dataset.swiperInitialized = "true";

    const slideThumbHeight = () => {
      const productThumbnails = e.querySelectorAll(".card--client-height");

      if (productThumbnails.length > 0) {
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnails[0].clientHeight / 2}px`
        );
      }
    };

    slideThumbHeight();
    window.addEventListener("resize", slideThumbHeight);
  }

  return Slider;
})();